import { createSlice } from '@reduxjs/toolkit';
import { NO_CURRENT_ENTITY } from 'consts/store';
import { DATA_UNDEFINED, NO_ERRORS } from 'consts/xhr';
import {
  pendingActionHandler,
  readyActionHandler,
  rejectActionHandler,
} from 'helpers/sliceHelpers';
import {
  getCounterOfferFlights,
  createCounterOfferFlight,
  updateCounterOfferFlight,
  deleteCounterOfferFlight,
} from './counterOfferFlights.actions';
import adapter from './counterOfferFlights.adapter';
import { REDUCER_KEY } from './counterOfferFlights.consts';
//import { removeCounterOffer } from 'store/proposals/counterOffer/counterOfferProposals.actions';

const slice = createSlice({
  name: REDUCER_KEY,
  initialState: {
    ...adapter.getInitialState(),
    status: DATA_UNDEFINED,
    errors: NO_ERRORS,
    current: NO_CURRENT_ENTITY,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getCounterOfferFlights.fulfilled, (state, action) =>
        adapter.setAll(state, action.payload),
      )
      .addCase(createCounterOfferFlight.fulfilled, (state, action) =>
        adapter.upsertMany(state, action.payload),
      )
      .addCase(updateCounterOfferFlight.fulfilled, (state, action) =>
        adapter.upsertOne(state, action.payload),
      )
      .addCase(deleteCounterOfferFlight.fulfilled, (state, action) =>
        adapter.removeOne(state, action.payload),
      ) /* 
      .addCase(removeCounterOffer.fulfilled, state => {
        adapter.removeAll(state);
      }) */
      .addCase(REDUCER_KEY + '/removeAll', state => adapter.removeAll(state))
      .addMatcher(
        ({ type }) =>
          type.startsWith(REDUCER_KEY) && type.endsWith('fulfilled'),
        readyActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('pending'),
        pendingActionHandler,
      )
      .addMatcher(
        ({ type }) => type.startsWith(REDUCER_KEY) && type.endsWith('rejected'),
        rejectActionHandler,
      );
  },
});

export const { reducer } = slice;
